import PortfolioAllocationContainer from "./PortfolioAllocationContainer";
import PortfolioAllocationStore from "./PortfolioAllocationStore";

export default PortfolioAllocationStore(PortfolioAllocationContainer);